import { createSlice, createAsyncThunk } from "@reduxjs/toolkit";
import {
  ActivationRatingAndReviewApi,
  DeleteRatingAndReviewApi,
  DeleteRatingandreviewUploadFileApi,
  GetRatingandreviwsApi,
  GetTenantRatingandreviwsApi,
  PostRatingAndReviewApi,
  RatingandreviewUploadFileApi,
  UpdateRatingAndReviewApi,
} from "../../api/ecommerce/ProductCustomerReviewApi";

// Async thunks for API calls
export const GetRatingandreviews = createAsyncThunk(
  "review/GetRatingandreviws",
  async (payload, { rejectWithValue }) => {
    try {
      const response = await GetRatingandreviwsApi(payload);
      console.log(response?.data);
      return response?.data;
    } catch (err) {
      return rejectWithValue({
        errorMessage: err?.response?.data?.message,
      });
    }
  },
);

export const GetTenantRatingandreviews = createAsyncThunk(
  "review/GetTenantRatingandreviws",
  async (payload, { rejectWithValue }) => {
    try {
      const response = await GetTenantRatingandreviwsApi(payload);
      return response?.data;
    } catch (err) {
      return rejectWithValue({
        errorMessage: err?.response?.data?.message,
      });
    }
  },
);

export const DeleteRatingAndReview = createAsyncThunk(
  "review/DeleteRatingAndReview",
  async (payload, { rejectWithValue }) => {
    try {
      const response = await DeleteRatingAndReviewApi(payload);
      return response?.data;
    } catch (err) {
      return rejectWithValue({
        errorMessage: err?.response?.data?.message,
      });
    }
  },
);

export const ActivationRatingAndReview = createAsyncThunk(
  "review/ActivationRatingAndReview",
  async (payload, { rejectWithValue }) => {
    try {
      const response = await ActivationRatingAndReviewApi(payload);
      return response?.data;
    } catch (err) {
      return rejectWithValue({
        errorMessage: err?.response?.data?.message,
      });
    }
  },
);

export const PostRatingAndReview = createAsyncThunk(
  "review/PostRatingAndReview",
  async (payload, { rejectWithValue }) => {
    try {
      const response = await PostRatingAndReviewApi(payload);
      return response?.data;
    } catch (err) {
      return rejectWithValue({
        errorMessage: err?.response?.data?.message,
      });
    }
  },
);

export const UpdateRatingAndReview = createAsyncThunk(
  "review/UpdateRatingAndReview",
  async (payload, { rejectWithValue }) => {
    try {
      const response = await UpdateRatingAndReviewApi(payload);
      return response?.data;
    } catch (err) {
      return rejectWithValue({
        errorMessage: err?.response?.data?.message,
      });
    }
  },
);

export const RatingandreviewUploadFileImag = createAsyncThunk(
  "review/RatingandreviewUploadFileImag",
  async (payload, { rejectWithValue }) => {
    try {
      const response = await RatingandreviewUploadFileApi(payload);
      return response?.data;
    } catch (err) {
      return rejectWithValue({
        errorMessage: err?.response?.data?.message,
      });
    }
  },
);

export const RatingandreviewUploadFileImgDelete = createAsyncThunk(
  "review/RatingandreviewUploadFileImgDelete",
  async (payload, { rejectWithValue }) => {
    try {
      const response = await DeleteRatingandreviewUploadFileApi(payload);
      return response?.data;
    } catch (err) {
      return rejectWithValue({
        errorMessage: err?.response?.data?.message,
      });
    }
  },
);

export const RatingandreviewUploadFileVideo = createAsyncThunk(
  "review/RatingandreviewUploadFileVideo",
  async (payload, { rejectWithValue }) => {
    try {
      const response = await RatingandreviewUploadFileApi(payload);
      return response?.data;
    } catch (err) {
      return rejectWithValue({
        errorMessage: err?.response?.data?.message,
      });
    }
  },
);

export const RatingandreviewUploadFileVideoDelete = createAsyncThunk(
  "review/RatingandreviewUploadFileVideoDelete",
  async (payload, { rejectWithValue }) => {
    try {
      const response = await DeleteRatingandreviewUploadFileApi(payload);
      return response?.data;
    } catch (err) {
      return rejectWithValue({
        errorMessage: err?.response?.data?.message,
      });
    }
  },
);

// Initial state
const initialState = {
  reviewImg: {},
  reviewVideo: {},
  reviews: [],
  reviewsTenant: {},
  selectedProduct: {},
  loading: false,
  processing: false,
};

// Slice definition
const ProductCustomerReviewSlice = createSlice({
  name: "review",
  initialState,
  reducers: {
    setSelectedProduct: (state, action) => {
      state.selectedProduct = action.payload;
    },
  },
  extraReducers: (builder) => {
    builder
      .addCase(GetRatingandreviews.pending, (state) => {
        state.loading = true;
      })
      .addCase(GetRatingandreviews.fulfilled, (state, action) => {
        state.loading = false;
        state.reviewsTenant = action.payload.response;
      })
      .addCase(GetRatingandreviews.rejected, (state, action) => {
        state.loading = false;
      });

    builder
      .addCase(GetTenantRatingandreviews.pending, (state) => {
        state.loading = true;
      })
      .addCase(GetTenantRatingandreviews.fulfilled, (state, action) => {
        state.loading = false;
        state.reviewsTenant.content = action.payload.response || [];
      })
      .addCase(GetTenantRatingandreviews.rejected, (state, action) => {
        state.loading = false;
      });

    builder
      .addCase(DeleteRatingAndReview.pending, (state) => {
        state.processing = true;
      })
      .addCase(DeleteRatingAndReview.fulfilled, (state, action) => {
        state.processing = false;
        // state.reviewImg = action.payload.response;
      })
      .addCase(DeleteRatingAndReview.rejected, (state, action) => {
        state.processing = false;
      });

    builder
      .addCase(ActivationRatingAndReview.pending, (state) => {
        state.processing = true;
      })
      .addCase(ActivationRatingAndReview.fulfilled, (state, action) => {
        state.processing = false;
        // state.reviewImg = action.payload.response;
      })
      .addCase(ActivationRatingAndReview.rejected, (state, action) => {
        state.processing = false;
      });

    builder
      .addCase(PostRatingAndReview.pending, (state) => {
        state.loading = true;
      })
      .addCase(PostRatingAndReview.fulfilled, (state, action) => {
        state.loading = false;
        // state.reviewImg = action.payload.response;
      })
      .addCase(PostRatingAndReview.rejected, (state, action) => {
        state.loading = false;
      });

    builder
      .addCase(UpdateRatingAndReview.pending, (state) => {
        state.loading = true;
      })
      .addCase(UpdateRatingAndReview.fulfilled, (state, action) => {
        state.loading = false;
        // state.reviewImg = action.payload.response;
      })
      .addCase(UpdateRatingAndReview.rejected, (state, action) => {
        state.loading = false;
      });

    builder
      .addCase(RatingandreviewUploadFileImag.pending, (state) => {
        state.loading = true;
      })
      .addCase(RatingandreviewUploadFileImag.fulfilled, (state, action) => {
        state.loading = false;
        state.reviewImg = action.payload.response;
      })
      .addCase(RatingandreviewUploadFileImag.rejected, (state, action) => {
        state.loading = false;
      });

    builder
      .addCase(RatingandreviewUploadFileImgDelete.pending, (state) => {
        state.loading = true;
      })
      .addCase(
        RatingandreviewUploadFileImgDelete.fulfilled,
        (state, action) => {
          state.loading = false;
          state.reviewImg = {};
        },
      )
      .addCase(RatingandreviewUploadFileImgDelete.rejected, (state, action) => {
        state.loading = false;
      });

    builder
      .addCase(RatingandreviewUploadFileVideo.pending, (state) => {
        state.loading = true;
      })
      .addCase(RatingandreviewUploadFileVideo.fulfilled, (state, action) => {
        state.loading = false;
        state.reviewVideo = action.payload.response;
      })
      .addCase(RatingandreviewUploadFileVideo.rejected, (state, action) => {
        state.loading = false;
      });
    builder
      .addCase(RatingandreviewUploadFileVideoDelete.pending, (state) => {
        state.loading = true;
      })
      .addCase(
        RatingandreviewUploadFileVideoDelete.fulfilled,
        (state, action) => {
          state.loading = false;
          state.reviewVideo = {};
        },
      )
      .addCase(
        RatingandreviewUploadFileVideoDelete.rejected,
        (state, action) => {
          state.loading = false;
        },
      );
  },
});

export default ProductCustomerReviewSlice.reducer;
export const { setSelectedProduct } = ProductCustomerReviewSlice.actions;
